import React from "react";

const TimeIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10.413"
        height="12.815"
        viewBox="0 0 10.413 12.815"
      >
        <path
          id="stopwatch-solid"
          d="M26.412,7.609a5.206,5.206,0,1,1-6.007-5.144V1.6h-.7a.3.3,0,0,1-.3-.3V.3a.3.3,0,0,1,.3-.3h3a.3.3,0,0,1,.3.3v1a.3.3,0,0,1-.3.3h-.7v.864a5.174,5.174,0,0,1,2.5,1.116l.688-.688a.3.3,0,0,1,.425,0l.708.708a.3.3,0,0,1,0,.425l-.736.736-.015.015A5.154,5.154,0,0,1,26.412,7.609Zm-4.405.9V4.718a.3.3,0,0,0-.3-.3h-1a.3.3,0,0,0-.3.3V8.51a.3.3,0,0,0,.3.3h1A.3.3,0,0,0,22.007,8.51Z"
          transform="translate(-16)"
          fill="#1198ff"
        />
      </svg>
    </>
  );
};
export default TimeIcon;
